import moment from 'moment-timezone';

import LocalStorageService from 'web-app/services/local-storage';

export const TOKEN_REFRESH_TIMESTAMP_KEY = 'accessTokenRefreshTimestamp';
export const EXPECTED_EXPIRATION_TIMESTAMP_KEY = 'expectedExpirationTimestamp';
export const ACCESS_TOKEN_KEY = 'accessToken';

export const isAccessTokenExpired = () => {
    const now = moment();
    const expectedExpirationTimestamp = LocalStorageService.getFromLocalStorage(EXPECTED_EXPIRATION_TIMESTAMP_KEY);
    const expectedExpirationMoment = moment(expectedExpirationTimestamp);
    return expectedExpirationMoment.isValid() ? now.isAfter(expectedExpirationMoment) : false;
};
